import { render, staticRenderFns } from "./ErrorSubmitForm5.vue?vue&type=template&id=eb7dc67e&scoped=true"
import script from "./ErrorSubmitForm5.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7dc67e",
  null
  
)

export default component.exports